var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"user_grzx"},[(_vm.grzs_show==1)?_c('grzx',{ref:"grzx",attrs:{"user_info":_vm.user_info}}):_vm._e(),(_vm.grzs_show==2)?_c('grzxls',{ref:"grzxls",attrs:{"user_info":_vm.user_info}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }